/**
 * Claves de localStorage con scope por tenant.
 *
 * El mismo build del CRM se sirve a ~10 marcas (por hostname o por prefijo de
 * ruta); sin scope, dos tenants abiertos en el mismo navegador pisarían sus
 * claves entre sí (menú, preferencias de sidebar, etc.).
 *
 * Extraída de useUser.ts para reutilizarla en la persistencia del sidebar.
 */
export function tenantScopedLocalKey(baseKey: string): string {
  if (typeof window === "undefined") return baseKey
  const host = window.location.hostname.toLowerCase()
  const firstPath = window.location.pathname.replace(/^\/+/, "").split("/")[0]?.toLowerCase() || ""
  if (host.includes("claricel") || firstPath === "claricel") return `claricel:${baseKey}`
  if (host.includes("nxum") || firstPath === "nxum") return `nxum:${baseKey}`
  if (host.includes("infynit") || firstPath === "infynit") return `infynit:${baseKey}`
  if (host.includes("pandamovil") || firstPath === "pandamovil" || firstPath === "panda") return `pandamovil:${baseKey}`
  if (host.includes("celink") || firstPath === "celink") return `celink:${baseKey}`
  return baseKey
}
